<template>
  <div class="head">
    <img src="/static/image/logo_head.png" class="logo" />
    <img
      @click="menuShow = true"
      src="/static/image/btn_menu@2x.png"
      class="btn_menu"
    />

    <Drawer :closable="false" width="80%" v-model="menuShow">
      <img
        @click="menuShow = false"
        src="/static/image/menu_btn_close@2x.png"
        class="close_logo"
      />

      <div @click="changeMenu('home')" class="shouye">首页</div>

      <!-- <Menu active-name="1-2" :open-names="['1']" class="menu_view"> -->
      <Menu @on-select="changeMenu" class="menu_view">
        <!-- <MenuItem name="1-3">资质荣誉</MenuItem> -->

    
        <Submenu name="2">
          <template slot="title"> 核心技术 </template>
          <MenuItem name="coreTechnology">核心技术</MenuItem>
          <MenuItem name="5Key">5大优势</MenuItem>
          <MenuItem name="algorithm">自研算法</MenuItem>
        </Submenu>
        <Submenu name="3">
          <template slot="title"> 产品中心 </template>
          <MenuItem name="programme">内窥镜摄像系统解决方案</MenuItem>
          <MenuItem name="pad">智能会议平板解决方案</MenuItem>
          <MenuItem name="operatingRoom">数字一体化手术室解决方案</MenuItem>
        </Submenu>
        <Submenu name="4">
          <template slot="title"> 新闻中心 </template>
          <MenuItem name="news">新闻中心</MenuItem>
        </Submenu>
        <Submenu name="5">
          <template slot="title"> 服务支持 </template>
          <MenuItem name="support">服务支持</MenuItem>
        </Submenu>
        <Submenu name="6">
          <template slot="title"> 加入我们 </template>
          <MenuItem name="position">职位探索</MenuItem>
          <MenuItem name="welfare">福利待遇</MenuItem>
          <!-- <MenuItem name="environment">办公环境</MenuItem> -->
          <MenuItem name="contactUs">联系我们</MenuItem>
        </Submenu>
        <Submenu name="1">
          <template slot="title">
            <!-- <Icon type="ios-analytics" /> -->
            关于晨新
          </template>
          <MenuItem name="aboutCnew">关于晨新</MenuItem>
          <MenuItem name="hostory">发展历程</MenuItem>
          <!-- <MenuItem name="1-3">资质荣誉</MenuItem> -->
        </Submenu>
      </Menu>
    </Drawer>
  </div>
</template>

<script>
import { mapState, mapMutations } from "vuex";
export default {
  data() {
    return {
      localIndex: -1,
      menuShow: false,
      navs: [
        {
          name: "首页",
          path: "index",
        },
        {
          name: "关于晨新",
          path: "about",
        },
        {
          name: "核心技术",
          path: "hxjs",
        },
        {
          name: "产品中心",
          path: "cpzx",
        },
        {
          name: "新闻中心",
          path: "news",
        },
        {
          name: "服务支持",
          path: "support",
        },
        {
          name: "加入我们",
          path: "join",
        },
      ],
    };
  },
  created() {
    this.localIndex = window.localStorage.getItem("index");
  },
  computed: {
    ...mapState(["headerIndex", "scrollTop"]),
    pageWidth() {
      return window.innerWidth;
    },
  },
  mounted() {
    if (this.localIndex) {
      this.changeHeaderIndex(this.localIndex);
    }
  },
  methods: {
    ...mapMutations([
      "changeHeaderIndex",
      "changeaboutPageCurrentSelected",
      "changehxjsPageCurrentSelected",
      "changecpzxPageCurrentSelected",
      "changejoinusPageCurrentSelected",
    ]),
    
    changeMenu(path) {
      switch (path) {
        case "aboutCnew":
          if(this.$route.name != "aboutCnew"){
            this.$router.push({ name: "about" });
          }
        
            this.changeaboutPageCurrentSelected(0);
      
    
       

          break;
        case "hostory":
        if(this.$route.name != "aboutCnew"){
            this.$router.push({ name: "about" });
          }
        
        
            this.changeaboutPageCurrentSelected(1);
     
    
          break;

        case "coreTechnology":
        if(this.$route.name != "coreTechnology"){
          this.$router.push({ name: "hxjs" });
          }
       
          this.changehxjsPageCurrentSelected(0);
        
          break;
        case "5Key":
        if(this.$route.name != "coreTechnology"){
          this.$router.push({ name: "hxjs" });
          }
          this.changehxjsPageCurrentSelected(1);
         
          break;
        case "algorithm":
        if(this.$route.name != "coreTechnology"){
          this.$router.push({ name: "hxjs" });
          }
          this.changehxjsPageCurrentSelected(2);
         
          break;

        case "programme":
        if(this.$route.name != "programme"){
          this.$router.push({ name: "cpzx" });
          }
      
          this.changecpzxPageCurrentSelected(0);
          
          break;
        case "pad":
        if(this.$route.name != "programme"){
          this.$router.push({ name: "cpzx" });
          }
          this.changecpzxPageCurrentSelected(1);
          
          break;
        case "operatingRoom":
        if(this.$route.name != "programme"){
          this.$router.push({ name: "cpzx" });
          }
          this.changecpzxPageCurrentSelected(2);
         
          break;

        case "position":
 
        if(this.$route.name != "position"){
          this.$router.push({ name: "join" });
          }
          this.changejoinusPageCurrentSelected(0);
          
          break;
        case "welfare":
        if(this.$route.name != "position"){
          this.$router.push({ name: "join" });
          }
          this.changejoinusPageCurrentSelected(1);
         
          break;
        case "contactUs":
        if(this.$route.name != "position"){
          this.$router.push({ name: "join" });
          }
          this.changejoinusPageCurrentSelected(2);
          

        default:
        if(this.$route.name != path){
          this.$router.push({ name: path });
          }
   
          break;
      }

      this.menuShow = false;
    },
  },
};
</script>

<style lang="scss" scoped>
@keyframes gradient-animationT {
  0% {
    background-color: rgba(255, 255, 255, 0);
  } /* 初始状态为红色 */
  100% {
    background-color: rgba(255, 255, 255, 1);
  } /* 结束状态为黄色 */
}
.headS {
  background-color: rgba(255, 255, 255, 1);
  animation: gradient-animationT 0.2s linear 1;
  box-shadow: 0px 0px 10px 1px rgba(0, 0, 0, 0.1);
}

.head {
  width: 100%;
  height: 100%;
  position: relative;
  background-color: white;
  box-shadow: 0px 0px 10px 1px rgba(0, 0, 0, 0.1);
  .logo {
    position: absolute;
    width: 133px;
    left: 24px;
    top: 28px;
    height: 55px;
  }

  .btn_menu {
    position: absolute;
    width: 44px;
    right: 32px;
    top: 33px;
    height: 44px;
  }
}
.ivu-drawer-close {
  font-size: 44px !important;
}
.ivu-drawer-close .ivu-icon-ios-close {
  font-size: 44px !important;
}
.ivu-icon-ios-close {
  font-size: 44px !important;
}
.close_logo {
  position: absolute;
  top: 33px;
  right: 33px;
  width: 44px;
  height: 44px;
}

.ivu-menu {
  font-size: 30px !important;
}
.menu_view {
  margin-top: 20px;
  width: 100% !important;
  // background-color: aqua;
}
.shouye {
  font-size: 35px !important;
  margin-top: 110px;
  margin-left: 20px;
}
.ivu-menu-item {
  font-size: 28px !important;
}
.ivu-menu-vertical.ivu-menu-light:after {
  width: 0px !important;
}
.ivu-menu-light.ivu-menu-vertical
  .ivu-menu-item-active:not(.ivu-menu-submenu):after {
  width: 0px !important;
}
.ivu-menu-submenu{
  margin-bottom: 20px!important;
}
// .ivu-menu-item{
//   height: 90px!important;
// }
</style>



// WEBPACK FOOTER //
// src/components/Header.vue